import { createApi } from "@reduxjs/toolkit/query/react";
import { extendedBaseQuery } from "../basequery";

export const permissionApi = createApi({
  reducerPath: "permissionApi",
  baseQuery: extendedBaseQuery,
  tagTypes: ["Permission"],
  endpoints: (builder) => ({
    getPermissions: builder.query({
      query: (params) => {
        const query = {};
        if (params?.skip) query.skip = params.skip;
        if (params?.limit) query.limit = params.limit;
        if (params?.search) query.search = params.search;
        if (params?.filter) query.filter = params.filter;
        if (params?.sortBy) query.sortBy = params.sortBy;
        if (params?.orderBy) query.orderBy = params.orderBy;

        return {
          url: `permission?${new URLSearchParams(query).toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Permission"],
    }),
    createPermission: builder.mutation({
      query: (body) => ({
        url: "permission",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Permission"],
    }),
    updatePermission: builder.mutation({
      query: (body) => ({
        url: `permission/${body.id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["Permission"],
    }),
    deletePermission: builder.mutation({
      query: (id) => ({
        url: `permission/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Permission"],
    }),
    getPermissionsByUserId: builder.query({
      query: (body) => ({
        url: `permission/user/${body.userId}`,
        method: "GET",
      }),
      // providesTags: ["Permission"],
    }),
  }),
});

export const {
  useGetPermissionsQuery,
  useCreatePermissionMutation,
  useUpdatePermissionMutation,
  useDeletePermissionMutation,
  useGetPermissionsByUserIdQuery,
} = permissionApi;
